var _classCallCheck = require("/var/lib/jenkins/workspace/GLOTIO_glotio-frontend_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/lib/jenkins/workspace/GLOTIO_glotio-frontend_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var forOwn = require('lodash.forown');

var cloneDeep = require('lodash.clonedeep');

var tv4 = require('tv4');

var formats = require('tv4-formats');

var nullable = require('./nullable');
/**
 */


var SchemaValidator = /*#__PURE__*/function () {
  "use strict";

  /**
   * Create schema validator for schemas defined in spec at `#/components/schemas`
   *
   * @param {Object} spec API specification in OpenAPI Specification 3.0 format
   * @param {Object} [options={}] options
   * @param {Object} [options.customFormats] custom format validators
   * @param {boolean} [options.banUnknownProperties=false] disallow extra properties in validated objects
   */
  function SchemaValidator(spec) {
    var _this = this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        customFormats = _ref.customFormats,
        banUnknownProperties = _ref.banUnknownProperties;

    _classCallCheck(this, SchemaValidator);

    this.validator = tv4.freshApi();
    this.banUnknowns = banUnknownProperties;
    this.validator.addFormat(formats);

    if (customFormats) {
      this.validator.addFormat(customFormats);
    }

    forOwn(spec.components.schemas, function (schema, name) {
      return _this.validator.addSchema("#/components/schemas/".concat(name), toOpenApiSchema(schema));
    });
  }
  /**
   * Validate object against schema. Schema can be passed explicitly or reference a schema from spec.
   *
   * @param {Object} entity - object to validate
   * @param {Object|string} schema - object schema
   * @return {Array<Object>} An array with errors when object is invalid, `undefined` otherwise
   */


  _createClass(SchemaValidator, [{
    key: "validate",
    value: function validate(entity, schema) {
      var _this$validator$valid = this.validator.validateMultiple(entity, toOpenApiSchema(schema), true, this.banUnknowns),
          valid = _this$validator$valid.valid,
          errors = _this$validator$valid.errors;

      if (!valid) {
        return errors;
      }
    }
  }]);

  return SchemaValidator;
}();

module.exports = {
  SchemaValidator: SchemaValidator,
  ErrorCodes: tv4.errorCodes
};

var toOpenApiSchema = function toOpenApiSchema(schema) {
  var openApiSchema = cloneDeep(schema);
  nullable.support(openApiSchema);
  return openApiSchema;
};